var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"partner-view"},[_c('div',{staticClass:"wrapper"},[_c('img',{attrs:{"src":_vm.image}})]),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }